import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Stack,
  Divider,
  Button,
  TextField,
  InputAdornment,
} from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { useLocation, useNavigate } from "react-router-dom";
import Menus from "../../Components/Menu/Menu";
import IconButtonField from "../../Components/Button/IconButtonField";
import styles from "../Mockexampage/MockGrid.module.scss";
import Avatars from "../../Components/Avatar/Avatars";
import { listSubjectNote } from "../../Redux/Slices/StudyNote/SubjectStudyNode";
import Mockexamimage from "../Mockexampage/Imagemockexampage/MockExamimage.jpg";
import { listListSubjectNoteTopicSlice } from "../../Redux/Slices/StudyNote/TopicStudyNode";
import SearchIcon from "@mui/icons-material/Search";
import DescriptionIcon from "@mui/icons-material/Description";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { listListSubjectNoteSubTopicSlice } from "../../Redux/Slices/StudyNote/TopicSubStudyNode";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { listListSubjectNoteContentSlice } from "../../Redux/Slices/StudyNote/TopicStudyNodeContent";

const SubTopic = () => {
  const { state: subtopicid } = useLocation();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(listUser());
    dispatch(listListSubjectNoteSubTopicSlice({ topic_id: subtopicid }));
  }, [dispatch]);
  const { data: ListSubjectNoteSubTopic } = useAppSelector(
    (state) => state.ListSubjectNoteSubTopicSlice
  );
  const Subjectsubtopic: any = ListSubjectNoteSubTopic?.data;

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );

  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data?.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];

  const [search, setSearch] = useState("");

  const filteredData = Subjectsubtopic?.filter((item: any) =>
    item?.name?.toLowerCase().includes(search?.toLowerCase())
  );

  return (
    <div className="ExamprocessStudentAlingment">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Typography
            onClick={() => navigate(-1)}
            sx={{
              color: "#009DFF",
              cursor: "pointer",
              fontWeight: 500,
              ml: "20px",
              fontSize: "14px",
              display: "flex",
              flexdirection: "row",
              alignitems: "center",
              gap: "10px",
            }}
          >
            <ArrowBackIcon sx={{ verticalAlign: "middle", mr: 0.5 }} />
            Back to Study Notes
          </Typography>

          <Box ml={3}>
            <Typography variant="h4" sx={{ fontWeight: 700, fontSize: "24px" }}>
              {Array.isArray(Subjectsubtopic) && Subjectsubtopic.length > 0
                ? Subjectsubtopic[0].topic
                : "No topic available"}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: "gray",
                mt: "5px",
                fontSize: "17px",
                fontWeight: 400,
              }}
            >
              Mathematical concepts, algebra, arithmetic, and problem-solving
              techniques
            </Typography>
          </Box>
        </Box>
        <div>
          <Menus
            menuItems={[
              // {
              //   menu: "Profile",
              //   onClick: () => {
              //     nav("/studentprofile");
              //   },
              // },
              {
                menu: "Logout",
                onClick: () => {
                  sessionStorage.clear();
                  dispatch(clearListuser());
                  dispatch(clearLoginStatus());
                  navigate("/login");
                },
              },
            ]}
          >
            <IconButtonField onClick={() => {}}>
              <Avatars sx={{ height: "2rem", width: "2rem" }} />
            </IconButtonField>
          </Menus>
          <span className="Username">{ListUser[0]?.student_name}</span>
        </div>
      </div>
      <Grid container spacing={3}>
        <Box
          sx={{
            px: "2%",
            py: "2%",
            minHeight: "100vh",
            width: "100%",
          }}
        >
          {/* Search Input */}
          <Box sx={{ maxWidth: 400, mb: 3, mt: "20px" }}>
            <TextField
              fullWidth
              sx={{ borderRadius: "5px" }}
              variant="outlined"
              placeholder="Search topics..."
              size="small"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          {/* Topics List */}
          <Stack>
            {filteredData?.map((item: any, index: any) => (
              <Card
                onClick={() => {
                  dispatch(
                    listListSubjectNoteContentSlice({ subtopic_id: item?.id })
                  );
                  navigate("/content", { state: item?.id }); // Replace with your target route
                }}
                key={index}
                variant="outlined"
                sx={{
                  borderRadius: "px",
                  p: { xs: 2, md: 3 },
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "0px",
                  alignItems: "center",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 2,
                  transition: "background 0.3s",
                  "&:hover": {
                    backgroundColor: "#ffffffff",
                    cursor: "pointer",
                  },
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="h5"
                    fontWeight="500"
                    gutterBottom
                    sx={{
                      color: "text.primary",
                      cursor: "pointer",
                      "&:hover": {
                        color: "#009DFF", // or use theme color: "primary.main"
                      },
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.5, fontSize: "14px" }}
                  >
                    {item.description}
                  </Typography>

                  <Stack
                    direction="row"
                    spacing={3}
                    alignItems="center"
                    sx={{ mt: 1 }}
                  >
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <DescriptionIcon
                        fontSize="small"
                        sx={{ color: "#6b7280", fontSize: "15px" }}
                      />
                      <Typography
                        variant="caption"
                        sx={{ color: "#6b7280", fontSize: "15px" }}
                      >
                        {item.example_count}{" "}
                        {item.example_count > 1 ? "examples" : "example"}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <AccessTimeIcon
                        fontSize="small"
                        sx={{ color: "#6b7280", fontSize: "15px" }}
                      />
                      <Typography
                        variant="caption"
                        sx={{ color: "#6b7280", fontSize: "15px" }}
                      >
                        {item.total_timing}
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>

                <ChevronRightIcon sx={{ color: "#6b7280", fontSize: "30px" }} />
              </Card>
            ))}
          </Stack>
        </Box>
      </Grid>
    </div>
  );
};

export default SubTopic;
